import { useEffect, useState } from "react";
import { useDisclosure } from "@chakra-ui/react";

export function useShowNewsModal(
  storageKey = "newsModalProbabilisticInsightCount",
  maxShows = 2
) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    const getLoginCount = (): number => {
      const storedValue = localStorage.getItem(storageKey);
      return storedValue ? parseInt(storedValue, 10) : 0;
    };

    const incrementLoginCount = (currentCount: number) => {
      localStorage.setItem(storageKey, (currentCount + 1).toString());
    };

    const loginCount = getLoginCount();

    if (loginCount < maxShows) {
      setShouldShow(true);
      incrementLoginCount(loginCount);
    }
  }, [storageKey, maxShows]);

  useEffect(() => {
    if (shouldShow) {
      onOpen();
    }
  }, [shouldShow, onOpen]);

  return {
    isOpen,
    onClose,
  };
}
